export default __webpack_public_path__ + "static/media/Footpad's Tunic of the Deceiver.0ffd5b82.jpg";